export function formatHtml8203(value) {
  return value.replace(/\./g, '.' + String.fromCharCode(8203))
}
